import CircularProgressCustom from '@orientaction/components/CircularProgressCustom';
import { FC, useState } from 'react';
import { pyramidBlockText } from '../../../../../PageResultat/NeedsProResult/constant';
import VariableDetailsModal from '../components/DetailModal/NeedsDetailModal';
import { modalStaticBlockElement } from '../../../../../PageResultat/NeedsProResult/VariableDetailsModal/constant';
import RedesignImage from '../../../../shared/components/RedesignImage';
import ResultDetailCard from '../components/ResultDetailCard';
import {
  DetailsSection,
  SummaryCard,
  SummaryGrid,
  SummarySideCards,
} from '../components/SummarySection';
import { useMajorResultStyles } from '../MajorResult.styles';
import { MajorTestContentProps } from '../types';
import { needsAssets, needsRankColors } from './needsPresentation';

const getSubtitle = (key: string) => {
  const content = modalStaticBlockElement[key]?.toBeHappy?.content;
  if (!content) {
    return '';
  }
  const firstSentence = content.split('.')[0];
  return firstSentence ? `${firstSentence}.` : content.slice(0, 120);
};

const NeedsProContent: FC<MajorTestContentProps> = ({ myResult }) => {
  const classes = useMajorResultStyles();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedVariable, setSelectedVariable] = useState<any>(null);

  const favorite = myResult?.favorite;
  const variables = myResult?.treeMax || [];
  const pyramidSrc = needsAssets[favorite?.key]?.pyramid || favorite?.imgPyramid || '';

  const openModal = (variable: any) => {
    setSelectedVariable(variable);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedVariable(null);
  };

  return (
    <>
      <SummaryGrid>
        <SummaryCard title="SYNTHÈSE DE VOS RÉSULTATS">
          <p className={classes.summaryCardBody}>
            Voici votre besoin principal dans votre vie professionnelle
          </p>
          {favorite?.label && (
            <p className={classes.favoriteLabel} style={{ color: '#06163D' }}>
              {favorite.label}
            </p>
          )}
          {pyramidSrc && (
            <RedesignImage
              priority={true}
              src={pyramidSrc}
              alt="Pyramide des besoins"
              className={classes.pyramidImage}
            />
          )}
          <p className={classes.summaryCardBody}>{pyramidBlockText.description}</p>
        </SummaryCard>

        <SummarySideCards>
          <SummaryCard title="APPLICATION DANS VOTRE VIE PROFESSIONNELLE">
            <p>
              Si vous ne vous sentez pas pleinement satisfait(e) dans votre vie professionnelle,
              c’est sans doute parce que certains de vos besoins ne sont pas satisfaits. Tous ces
              éléments risquent d’entraîner de la démotivation. Au contraire, si vos besoins sont
              satisfaits, alors vous vous sentirez pleinement motivé(e) par votre travail.
            </p>
          </SummaryCard>
        </SummarySideCards>
      </SummaryGrid>

      <DetailsSection title="DÉCOUVREZ VOS 3 BESOINS PRINCIPAUX">
        {variables.map((variable: any, index: number) => {
          const imageSrc = needsAssets[variable.key]?.image || variable.path;
          const color = needsRankColors[index] || needsRankColors[0];
          const score = (variable.score * 100) / 125;

          return (
            <ResultDetailCard
              key={variable.key}
              label={variable.label}
              color={color}
              labelColor="#FFFFFF"
              imageSrc={imageSrc}
              imageAlt={variable.label}
              subtitle={getSubtitle(variable.key)}
              onLearnMore={() => openModal({ ...variable, color })}
              imageOverlay={
                <div className={classes.scoreBadge}>
                  <CircularProgressCustom
                    value={variable.score}
                    color={color}
                    size={78}
                    fontSize={18}
                    fontSizeFloat={12}
                    totalValue={125}
                    calculatedValue={score}
                  />
                </div>
              }
            />
          );
        })}
      </DetailsSection>

      <VariableDetailsModal
        open={modalOpen}
        onCancel={closeModal}
        modalStaticBlockElement={modalStaticBlockElement}
        variable={selectedVariable}
      />
    </>
  );
};

export default NeedsProContent;
